module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTeams),
      expression: "selectedTeams"
    }],
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTeams = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderedTeams), function(team, index) {
    return _c('option', {
      key: team.id,
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(team.name) + "\n\t\t")])
  })), _vm._v(" "), _c('input', {
    attrs: {
      "type": "",
      "name": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedTeams
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117d4304","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 26
// module chunks = 0